import { useLocation } from "react-router-dom";

// Sections that can appear right after the "chat" segment in the URL.
// Anything after these (or directly after "chat") is treated as a channelId.
const CHAT_SECTIONS = [
  "unreplied",
  "mymessages",
  "broadcast",
  "callhistory",
  "settings",
  "broadcasts",
  "call-broadcasts",
];

export type ChatSection = (typeof CHAT_SECTIONS)[number] | null;

// Derives chat routing info from the current URL, independent of where the
// chat page is mounted (/chat, /practice/chat, ...).
export const useChatLocation = () => {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  const chatIndex = segments.indexOf("chat");
  const isInChat = chatIndex !== -1;

  const afterChat = isInChat ? segments.slice(chatIndex + 1) : [];
  const section: ChatSection = CHAT_SECTIONS.includes(afterChat[0])
    ? afterChat[0]
    : null;
  const rest = section ? afterChat.slice(1) : afterChat;

  // A specific channel is open only when a channelId segment is present.
  const isChannelOpen = isInChat && rest.length > 0;
  const chatBasePath = isInChat
    ? `/${segments.slice(0, chatIndex + 1).join("/")}`
    : "";

  return { isInChat, isChannelOpen, chatBasePath, section };
};
